
        import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/plugins/panzoom/jquery.panzoom';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/components/figure-viewer/js/figure-viewer-script';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/widgets/publication-content/js/article';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/publication-content/js/crossref';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/article-tools/js/article-tools';
  
import '/mnt/ssd/na102/home/readonly/sourcegit/ui-products-branches/maint-241213-3ef24d6apericles12.2/ui-products/acropolis/pericles/node_modules/ui-core/widgets/publication-content/js/publication-content';
  
const main = (UX) => {
    const $figureViewer = Array.prototype.slice.call(document.querySelectorAll('.article-page figure:not(.holder), figure,.article-page .figure:not(.holder),.article-page .colored-block,.article-page .component-container')),
        $loader = Array.prototype.slice.call(document.querySelectorAll('.article-page > article'))

try {
        if ($figureViewer.length ) {
            UX.figureViewer.init($figureViewer);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        UX.loader.init();
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($loader.length ) {
            UX.loader.init($loader);
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        